module.exports = __webpack_public_path__ + "b3inventory.e68bed486908e61c0bbd.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/yardobject/font/b3inventory.woff?14714644
// module id = 899
// module chunks = 3